// @TODO: Убедиться, что этот файл нужен
import Highcharts from 'highcharts';
import 'highcharts/modules/heatmap';

export default Highcharts; 